import { useQuery } from '@tanstack/react-query';
import { container } from '@src/container';
import { GetPublicPascoFilterOptionsUseCase } from '@src/application/pascos/usecases';

export const useGetPublicPascoFilterOptions = () => {
    const getPublicPascoFilterOptionsUseCase = container.resolve<GetPublicPascoFilterOptionsUseCase>('GetPublicPascoFilterOptionsUseCase');

    return useQuery({
        queryKey: ['pascos', 'public', 'filter-options'],
        queryFn: () => getPublicPascoFilterOptionsUseCase.execute(),
    });
};